import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, Lock } from 'lucide-react';
import Navbar from '../Navbar';
import { Hero } from './Hero';
import { LectureSignupForm } from './LectureSignupForm';
import { FONT, MONO } from './ui';

const API = process.env.REACT_APP_BACKEND_URL;

// Public preview of a lecture for visitors: hero + promise + sign-up.
export const LectureTeaser = ({ slug, language, portrait, t }) => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/api/lectures/public/${slug}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [slug]);
  if (!d) return <div className="min-h-screen bg-[#040919] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-blue-200" /></div>;
  const L = (o) => (o && typeof o === 'object' && !Array.isArray(o) ? o[language] ?? o.en : o);
  const it = language === 'it';
  return (
    <div className="bg-[#040919] min-h-screen" data-testid="lecture-teaser">
      <Navbar />
      <Hero d={d} L={L} t={t} portrait={portrait} />
      <section className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 grid lg:grid-cols-[1.1fr_1fr] gap-12 items-start text-white" id="registrati">
        <div className="space-y-6">
          <p className="text-xs uppercase tracking-[0.25em] text-blue-300" style={MONO}>{t.promise}</p>
          <p className="text-3xl lg:text-4xl font-extrabold leading-tight" style={FONT}>{L(d.promise)}</p>
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 space-y-2 text-blue-100/80 text-sm">
            <p className="flex items-center gap-2 font-bold text-white"><Lock className="w-4 h-4 text-blue-300" /> {it ? 'Dopo la registrazione trovi:' : 'After signing up you get:'}</p>
            {(it
              ? ['Il programma completo, i tre casi e il laboratorio', 'Le clip video da analizzare', 'Tutta la bibliografia con i link alle fonti', 'La scheda gratuita /ʊ/ FOOT del Phonetic Lab, il test di livello e il Vocal Tract Lab']
              : ['The full programme, the three cases and the lab', 'The video clips to analyse', 'The full bibliography with links to sources', 'The free /ʊ/ FOOT card of the Phonetic Lab, the level test and the Vocal Tract Lab']
            ).map((x) => <p key={x}>· {x}</p>)}
          </div>
        </div>
        <div className="rounded-3xl bg-white/[0.06] border border-white/15 backdrop-blur-md p-7" data-testid="lecture-teaser-signup">
          <p className="text-2xl font-extrabold mb-1" style={FONT}>{it ? 'Registrati gratis' : 'Sign up for free'}</p>
          <p className="text-sm text-blue-100/70 mb-5">{it ? 'Accesso immediato alla lecture.' : 'Instant access to the lecture.'}</p>
          <LectureSignupForm slug={slug} lang={language} dark />
        </div>
      </section>
    </div>
  );
};
